import type React from 'react';

import { Alert } from '@change/ds-core-ui';

import { useMembershipModalState } from '../modalContext';

export const GeneralErrorMessage: React.FC = () => {
	const [{ formState }] = useMembershipModalState();
	if (formState?.status !== 'error') return null;

	return (
		<Alert variant="error" className="my-4" data-testid="form-error">
			{formState.error}
		</Alert>
	);
};
